enum CommentVisibility{
  Public = 0,
  Internal = 1
}

export default CommentVisibility;
